










import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

/**
 * A simplified version of JdhInputArea, meant for very small composite UIs.
 *
 * TODO: support errors via bubbles, and icons for prefixes.
 * TODO: support mini-dropdowns for basic selects.
 */
@Component({})
export default class JdhMicroInput extends Vue {

    @Prop({default: false, type: Boolean}) focus!: boolean
    @Prop({default: false, type: Boolean}) error!: boolean

    emitClick() {
        this.$emit('click')
    }

    get classes() {
        return [
            ... this.focus ? ['jdsc-input-area--focus'] : [],
            ... this.error ? ['jdsc-input-area--error'] : [],
        ]
    }

}
